import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AccountForm from './AccountForm';
import Login from './Login';

const path = window.location.pathname;

let page;
if (path === '/createAccount') {
  page = <AccountForm mode="create" />;
} else if (path === '/account/edit') {
  page = <AccountForm mode="edit" />;
} else if (path === '/login') {
  page = <Login />;
} else {
  page = <App />;
}

ReactDOM.render(
  <React.StrictMode>
    {page}
  </React.StrictMode>,
  document.getElementById('root')
);

window.addEventListener("load", function() {
    document.body.style.backgroundImage = "url('/images/background-18.jpg')";
});